"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "poggio-bustone": {
    "8d84fa1c": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-acquarisciana": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "176936f8": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-colli": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f5d7731": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "villa-bravi": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9947969": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "villa-coenere": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc82309b": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "villa-roma": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "13e70c63": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "skipSearch": false
    }],
    "villa-tizzi": [{
      "hkey": "3a5aff5c",
      "slug": "poggio-bustone",
      "name": "Poggio Bustone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;